import { render } from "./WizardReview.vue?vue&type=template&id=7807c996"
import script from "./WizardReview.vue?vue&type=script&lang=js"
export * from "./WizardReview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__